import React, {Component} from "react";
import MainHeader from "./MainHeader";
import Logo from "../Images/Logo_White.png";
import SearchImageWhite from "../Images/Group 8085.svg";
import {Container, Grid, Image} from "semantic-ui-react";
//import MainImage from "../Images/Warehouse-loadingbay-night.png";
import MainImage from "../Images/IPODocuments-01.jpg";
import MobileMainImage from "../Images/IPODocuments-01.jpg";
import Footer from "./Footer";
import jQuery from "jquery";

export default class RegulatoryNews extends Component {
    constructor(props) {
        super(props);

        this.updateWidgetHeight = this.updateWidgetHeight.bind(this);
    };

    updateWidgetHeight(event) {
        const frames = document.getElementsByTagName('iframe');
        for (let i = 0; i < frames.length; i++) {
            if (frames[i].contentWindow === event.source) {
                jQuery(frames[i]).height(event.data);
                break;
            }
        }
    }

    componentDidMount() {
        window.addEventListener('message', this.updateWidgetHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.updateWidgetHeight)
    }

    mainImage = () => {
        if(this.props.mobileSite === true) {
            return (
                <Image className='mainImage' src={MobileMainImage}/>
            )
        }
        else {
            return (
                <Image className='mainImage' src={MainImage}/>
            )
        }
    }

    mainHeader = () => {
        if(this.props.mobileSite === true) {
            return (
                <Container className='resultsContainer2'>
                    <h2 className='mobileResultsHeader'>Regulatory news & alerts</h2>
                </Container>
            )
        }
        else {
            return (
                <Container className='regContainer2'>
                    <h2 className='h2'>Regulatory news & alerts</h2>
                </Container>
            )
        }
    }

    render() {
        return (
            <div className='regulatoryNews'>
                <Grid className='mainGrid'>
                    <Grid.Row className='investorsRows'>
                        <MainHeader mobileSite={this.props.mobileSite} logo={Logo} h3='h3_white' shopButton='shopButton'
                                    menuDropdown='whiteDropdown' searchImage={SearchImageWhite}
                                    sharePriceUrl="https://irtools.co.uk/tools/share_price/db9f7736-8152-4900-8987-5ca09eb494c4"
                                    navLinks='nav-links' hamburgerColour='white'/>
                        {this.mainImage()}
                    </Grid.Row>
                    <Grid.Row>
                        <Container className='resultsContainer1'>
                            {this.mainHeader()}
                            <Container className='rnsWidgetContainer'>
                                <iframe title='rns news widget' className="rnsIFrame" src="https://irtools.co.uk/tools/news/9df2e8cc-c48b-469f-8358-8e47106af20d"/>
                            </Container>
                        </Container>
                    </Grid.Row>
                </Grid>
                <Footer mobileSite={this.props.mobileSite}/>
            </div>
        )
    }
}